import { createFileRoute } from "@tanstack/react-router";
import Page, { seo } from "@/pages/services/client-portal";
import { buildServiceHead } from "@/lib/service-seo";

export const Route = createFileRoute("/services/client-portal")({
  head: () => buildServiceHead(seo),
  component: Page,
});
